export default {
  properties: (state) => state.properties,
};
